import React from "react";
// import data from "./data";
import SearchResult from "./searchResult";

import "./style.scss";

const SearchResults = ({ data = [] }) => {
  return (
    <ul class="search-results">
      {data.map((searchResult) => (
        <SearchResult {...searchResult} />
      ))}
    </ul>
  );
};

export default SearchResults;
